import { InjectionToken, Signal, signal } from '@angular/core';

const BREAKPOINT_MD = 767;

/**
 * Mobile = a narrow screen OR a touch device on a short viewport. The second half catches the
 * phone held sideways (844×390): wide enough to pass the width test, yet too short for a desktop
 * dialog box — it must get the sheet. `pointer: coarse` keeps touch tablets on the desktop layout.
 */
export const MOBILE_QUERY = `(max-width: ${BREAKPOINT_MD}px), ((pointer: coarse) and (max-height: 500px))`;
// CSS twin: the `dlg-phone` / `dlg-desktop` variants in libs/frontend/shared/styles/ds-theme.css.

export const IS_MOBILE = new InjectionToken<Signal<boolean>>('IS_MOBILE', {
  providedIn: 'root',
  factory: () => {
    const mql = window.matchMedia(MOBILE_QUERY);
    const mobile = signal(mql.matches);
    mql.addEventListener('change', (e: MediaQueryListEvent) => mobile.set(e.matches));
    return mobile.asReadonly();
  },
});
